import * as React from "react";
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.65}
      d="M14.666 5.444h-4.444A4.444 4.444 0 0 0 5.777 9.89v26.667A4.444 4.444 0 0 0 10.222 41h22.222a4.444 4.444 0 0 0 4.444-4.444V9.889a4.444 4.444 0 0 0-4.444-4.445H28m-13.334 0a4.444 4.444 0 0 0 4.445 4.445h4.444A4.444 4.444 0 0 0 28 5.444m-13.334 0A4.444 4.444 0 0 1 19.111 1h4.444A4.444 4.444 0 0 1 28 5.444M21.333 21H28m-6.667 8.889H28M14.666 21h.022m-.022 8.889h.022"
    />
  </svg>
);
export default SvgComponent;
